<!--
 * @Author: liuYingBing
 * @Date: 2024-03-07 14:08:30
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-03-13 17:35:05
 * @FilePath: /fushigi/src/components/HeaderNotify.vue
 * @Description:
-->
<script setup lang="ts">
import { useHeaderNotify } from '@/store'
import { CloseOutlined } from '@ant-design/icons-vue'
const headerNotify = useHeaderNotify()
</script>

<template>
  <transition name="version-tip">
    <div v-if="headerNotify.status" class="header-notify px-6">
      <img src="@/assets/notify.svg" alt="" />
      <span class="notify-title"
        >通知：年终钜惠，算力狂欢！充值返赠18% + 消费抽AR眼镜 Switch + 新人50元代金券。<a
          href="https://club.huixingyun.com/article/864691128455495698"
          target="_blank"
          >详见</a
        >
      </span>
      <CloseOutlined class="close-icon" @click="headerNotify.close()" />
    </div>
  </transition>
</template>

<style scoped lang="less">
.header-notify {
  position: relative;
  background: #0066fffb;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 24px;
    width: 24px;
    margin-top: 8px;
    margin-right: 8px;
    align-self: flex-start;
  }
  .notify-title {
    font-weight: 550;
    font-size: 16px;
    color: #fff;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .close-icon {
    position: absolute;
    right: 10px;
    top: 12px;
    cursor: pointer;
    color: #f2ecec;
  }
}
</style>
